import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonPopupComponent } from './common-popup.component';

export interface CommonPopupAction {
    label: string;
    value?: any;
    handler?: () => void;
}

export interface CommonPopupOptions {
    title?: string;
    subTitle?: string;
    templateName?: string;
    html?: string;
    template?: TemplateRef<any>;
    context?: any;
    actions?: CommonPopupAction[];
}

@Injectable({ providedIn: 'root' })
export class CommonPopupService {
    constructor(private dialog: MatDialog) { }

    openSmall(options: CommonPopupOptions) {
        return this.dialog.open(CommonPopupComponent, {
            data: options,
            width: '480px',
            maxWidth: '95vw',
            position: { top: '24px' },
            panelClass: 'common-popup-panel'
        });
    }

    openLarge(options: CommonPopupOptions) {
        return this.dialog.open(CommonPopupComponent, {
            data: options,
            width: '900px',
            maxWidth: '98vw',
            position: { top: '24px' },
            panelClass: 'common-popup-panel'
        });
    }

    openCustom(options: CommonPopupOptions, config: MatDialogConfig = {}) {
        return this.dialog.open(CommonPopupComponent, Object.assign({
            data: options,
            position: { top: '24px' },
            panelClass: 'common-popup-panel'
        }, config));
    }
}
